<script>
import { ref } from 'vue'
import { useStore } from '../../store'

export default {
  setup(props, { slots }) {
    const store       = useStore()
    const loading     = ref(false)
    const formatMoney = (cents) => store.formatMoney(cents)
    const remove      = (id) => updateCart(id, 0)
    const toggle      = () => {
      if (! store.drawers.cart) { store.getCart() }
      store.drawers.cart = ! store.drawers.cart
    }

    const changeQty = (action, id) => {
      var qty   = document.getElementById( 'qty-' + id )
      var max   = qty.getAttribute( 'max' ) ? qty.getAttribute( 'max' ) : 3
      var value = parseInt( qty.value )

      if ( action === '+' ) {
        if ( value < parseInt( max ) ) {
          value = value + 1;
        }
      } else {
        value = ( value > 1 ) ? ( parseFloat( value ) - 1 ) : 0;
      }

      updateCart( id, value )
    }

    const updateCart = (id, qty) => {
      loading.value = true
      const counts  = document.getElementsByClassName( 'cart-count' )
      const formD   = new FormData()
      formD.append('id', id)
      formD.append('quantity', qty)

      store.storeAJAX({
        method: 'post',
        url: '/cart/change.js',
        data: formD
      })
        .then((response) => {
          store.cart = response.data
          for (let i = 0; i < counts.length; i++) {
            counts[i].innerHTML = '(' + response.data.item_count + ')'
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          loading.value = false
        })
    }
    
    return () => slots.default({
      loading: loading.value,
      active: store.drawers.cart,
      cart: store.cart,
      toggle,
      changeQty,
      remove,
      formatMoney
    })
  }
}
</script>